export default {
  header: 'Asset parameter definitions',
  subheader: 'This page allows to manage custom asset parameters that may be reused in the signal builder.',
  empty: 'No user defined asset parameters are defined.',
  confirmDelete: {
    header: 'Löschen bestätigen',
    message: 'Du bist dabei, eine benutzerdefinierte Parameterdefinition zu löschen. Diese Definition wird möglicherweise von mehreren Assets verwendet.\n\nBist du sicher, dass du den Parameter "{parameter}" dauerhaft entfernen möchtest?',
  },
};
